import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MenuContextType {
  isMenuButtonVisible: boolean;
  setIsMenuButtonVisible: (visible: boolean) => void;
  isSidebarOpen: boolean;
  setIsSidebarOpen: (open: boolean) => void;
  isMobile: boolean;
  setIsMobile: (mobile: boolean) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMenuButtonVisible, setIsMenuButtonVisible] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  return (
    <MenuContext.Provider value={{ 
      isMenuButtonVisible, 
      setIsMenuButtonVisible,
      isSidebarOpen,
      setIsSidebarOpen,
      isMobile,
      setIsMobile
    }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = (): MenuContextType => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within a MenuProvider');
  }
  return context;
};
